import { Pressable, View } from 'react-native'
import { styled } from '~/core/styled'

export const Root = styled(Pressable, theme => {
  return {
    base: {
      minWidth: theme.sizingMediumlarge,

      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',

      gap: theme.spacingInlineOnepulse,

      borderRadius: theme.borderRadiusPill,
      borderWidth: theme.borderWidthQuarterpulse,
      borderColor: theme.colorActionBorderNeutralSecondaryEnabled,

      paddingHorizontal: theme.paddingInsetTwopulse,
      paddingVertical: theme.spacingStackOnepulse,

      backgroundColor: theme.colorActionFillNeutralSecondaryEnabled,
    },
    variants: {
      size: {
        sm: {
          height: theme.sizingSmall,
        },
        md: {
          height: theme.sizingMediumlarge,
        },
      },
      readOnly: {
        true: {
          borderColor: theme.colorActionBorderNeutralSecondaryDisabled,
          backgroundColor: theme.colorActionFillNeutralSecondaryDisabled,
        },
      },
      disabled: {
        true: {
          borderColor: theme.colorActionBorderNeutralSecondaryDisabled,
          borderWidth: theme.borderWidthQuarterpulse,
          backgroundColor: theme.colorActionFillNeutralSecondaryDisabled,
        },
      },
      isPressed: {
        true: {
          backgroundColor: theme.colorActionFillNeutralSecondaryPressed,
          borderColor: theme.colorActionBorderNeutralSecondaryPressed,
        },
      },
    },
    compoundVariants: [
      {
        variants: {
          isPressed: true,
          readOnly: true,
        },
        css: {
          borderColor: theme.colorActionBorderNeutralSecondaryDisabled,
          backgroundColor: theme.colorActionFillNeutralSecondaryDisabled,
        },
      },
    ],
  }
})

export const LabelContainer = styled(View, {
  base: {
    flexShrink: 1,
  },
})
